import type { PlatformDataClient } from "./index";
/** Stable IDs make retrying a hotel/taxi request safe after an uncertain response. */
export async function submitOrderRequest(
  client: PlatformDataClient,
  table: "hotel_booking_requests" | "taxi_orders",
  requestId: string,
  values: Record<string, unknown>,
) {
  const result = await client.from(table).insert({ ...values, id: requestId });
  if (!result.error) return result;
  // The first response may have been lost after commit. RLS limits this lookup to the owner.
  const existing = await client
    .from(table)
    .select(["id", ...Object.keys(values)].join(","))
    .eq("id", requestId)
    .maybeSingle();
  if (!existing.error && existing.data && typeof existing.data === "object") {
    const row = existing.data as Record<string, unknown>;
    const same = Object.entries(values).every(([key, value]) => {
      if (key.endsWith("_at") && value && row[key])
        return +new Date(String(value)) === +new Date(String(row[key]));
      return (value ?? null) === (row[key] ?? null);
    });
    if (same) return existing;
    return {
      data: null,
      error: {
        message:
          "This request was already submitted. Check Orders before starting another request.",
      },
    };
  }
  return result;
}
